import phoneVerification from "./../assets/img/phoneVerification.svg";
import verifyCode from "./../assets/img/verifyCode.svg";
import agreement from "./../assets/img/agreement.svg";
import accountInfo from "./../assets/img/accountInfo.svg";
import confirmAccountInfo from "./../assets/img/confirmAccountInfo.svg";
import getStartedAccount from "./../assets/img/getStartedAccount.svg";
import { CgHome } from "react-icons/cg";
import { TiFlashOutline, TiGroupOutline } from "react-icons/ti";
import { FiUsers } from "react-icons/fi";
import { RiRouteFill, RiRouteLine, RiShieldCheckLine, RiShieldUserLine } from "react-icons/ri";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { RiSteering2Line } from "react-icons/ri";
import { ImMakeGroup } from "react-icons/im";
import { BsGear } from "react-icons/bs";
import admin from "./../assets/img/admin-app.svg";
import mission from "./../assets/img/mission-app.svg";
import device from "./../assets/img/device-app.svg";
import storage from "./../assets/img/storage-app.svg";
import onboardSdk from "./../assets/img/onboard-app.svg";
import containerApp from "./../assets/img/container-app.svg";
import cameraObserverApp from "./../assets/img/cam-observer-app.svg";
import dockManagerApp from "./../assets/img/dock-manager-app.svg";
import { DeviceAdminIcon, DockAdminIcon, GuestAdminIcon } from "../ui/Icons/Icons";
import { MdOutlineDashboard, MdOutlineSdStorage, MdOutlineSpaceDashboard, MdQueryStats, MdStorage } from "react-icons/md";
import { BiJoystick, BiMap, BiMapAlt, BiMapPin } from "react-icons/bi";
import { TbBrandAws, TbMapBolt, TbSettings } from "react-icons/tb";

export const VerificationCodeLength = 6;
export const meterToFootRatio = 3.28084;
export const footToMeterRatio = 0.3048;
export const meterToMileRatio = 2.23694;
export const mileToMeterRatio = 0.44704;

export const DOCK_VIDEO_STREAM_SERVER = 'https://20.224.196.6:8889';
export const DOCK_VIDEO_STREAM_AUTH = 'Basic YXZldGljc3U6YXZldGljc3A=';

export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZGFuaWVsaW50dWl0aXZlIiwiYSI6ImNsOXFydWVnMDA4c28zbnFsYmFuMWpidmIifQ.05aJvcMIyceNQgs5s4DMGw';

export const applicationItems = [
  {
    id: "mission-1",
    name: "Mission App",
    link: "/dashboard/mission-app",
    image: mission,
    color: "#2699fb",
    // color: "#ff6e40",
  },
  {
    id: "device",
    name: "Device App",
    link: "/dashboard/device-app",
    image: device,
    color: "#2699fb",
    // color: "#00b938",
  },
  {
    id: "storage",
    name: "Storage App",
    link: "/dashboard/storage-app",
    image: storage,
    color: "#2699fb",
    // color: "#9c27b0",
  },
  {
    id: "admin",
    name: "Admin Center",
    link: "/admin/home",
    image: admin,
    color: "#2699fb",
    // color: "#2699fb",
  },
];

export const appLauncherItems = [
  // {
  //   id: 1,
  //   title: "Dashboard",
  //   name: "dashboard",
  //   defaultImage: <MdOutlineSpaceDashboard />,
  //   color: "#004ab3",
  //   link: "/dashboard",
  //   selected: false,
  // },
  // {
  //   selected: false,
  //   id: 2,
  //   title: "Device",
  //   name: "device",
  //   defaultImage: <BiJoystick />,
  //   color: "#00b938",
  //   link: "/dashboard/device-app",
  // },
  // {
  //   selected: false,
  //   id: 3,
  //   title: "Security",
  //   name: "security",
  //   defaultImage: <TiFlashOutline />,
  //   color: "#00b938",
  //   link: "/dashboard/security-app",
  // },
  {
    selected: false,
    id: 4,
    title: "Explore",
    name: "explore",
    defaultImage: <BiMapPin />,
    color: "#00b938",
    link: "/dashboard/explore-app",
  },
  // {
  //   selected: false,
  //   id: 5,
  //   title: "Mission",
  //   name: "mission",
  //   defaultImage: <RiRouteLine />,
  //   color: "#ff6e40",
  //   link: "/dashboard/mission-app",
  // },
  // {
  //   selected: false,
  //   id: 6,
  //   title: "Storage",
  //   name: "storage",
  //   defaultImage: <MdOutlineSdStorage />,
  //   color: "#9c27b0",
  //   link: "/dashboard/storage-app",
  // },
  {
    selected: false,
    id: 7,
    title: "Reporting",
    name: "reporting",
    defaultImage: <MdQueryStats />,
    color: "#00b938",
    link: "/dashboard/reporting-app/missions",
  },
  {
    id: 8,
    title: "Admin",
    name: "admin",
    defaultImage: <RiShieldCheckLine />,
    color: "#2699fb",
    link: "/admin/home",
    selected: false,
  },
];

export const menuItems = [
  {
    id: 1,
    title: "Dashboard",
    name: "dashboard",
    defaultImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.837"
        height="16.766"
        viewBox="0 0 16.837 16.766"
      >
        <g id="Category" transform="translate(-2 1)">
          <path
            id="Stroke_1"
            data-name="Stroke 1"
            d="M1.8,0H4.2A1.8,1.8,0,0,1,6,1.8V4.2A1.8,1.8,0,0,1,4.2,6H1.8A1.8,1.8,0,0,1,0,4.2V1.8A1.8,1.8,0,0,1,1.8,0Z"
            transform="translate(11.837 0)"
            fill="none"
            stroke="#0f83a2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
            opacity="0.4"
          />
          <path
            id="Stroke_3"
            data-name="Stroke 3"
            d="M1.8,0H4.2A1.8,1.8,0,0,1,6,1.8V4.2A1.8,1.8,0,0,1,4.2,6H1.8A1.8,1.8,0,0,1,0,4.2V1.8A1.8,1.8,0,0,1,1.8,0Z"
            transform="translate(3 0)"
            fill="none"
            stroke="#0f83a2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path
            id="Stroke_5"
            data-name="Stroke 5"
            d="M1.8,0H4.2A1.8,1.8,0,0,1,6,1.8V4.2A1.8,1.8,0,0,1,4.2,6H1.8A1.8,1.8,0,0,1,0,4.2V1.8A1.8,1.8,0,0,1,1.8,0Z"
            transform="translate(3 8.766)"
            fill="none"
            stroke="#0f83a2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path
            id="Stroke_7"
            data-name="Stroke 7"
            d="M1.8,0H4.2A1.8,1.8,0,0,1,6,1.8V4.2A1.8,1.8,0,0,1,4.2,6H1.8A1.8,1.8,0,0,1,0,4.2V1.8A1.8,1.8,0,0,1,1.8,0Z"
            transform="translate(11.837 8.766)"
            fill="none"
            stroke="#0f83a2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </g>
      </svg>
    ),
    hoveredImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22.5"
        height="22.5"
        viewBox="0 0 22.5 22.5"
      >
        <g id="Category" transform="translate(1.25 1.25)">
          <path
            id="Stroke_1"
            data-name="Stroke 1"
            d="M2.449,0H5.716A2.459,2.459,0,0,1,8.163,2.47V5.764a2.46,2.46,0,0,1-2.448,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.47A2.46,2.46,0,0,1,2.449,0Z"
            transform="translate(11.837 0)"
            fill="none"
            stroke="#e7f3fe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2.5"
            opacity="0.4"
          />
          <path
            id="Stroke_3"
            data-name="Stroke 3"
            d="M2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.47V5.764a2.46,2.46,0,0,1-2.449,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.47A2.46,2.46,0,0,1,2.449,0Z"
            transform="translate(0 0)"
            fill="none"
            stroke="#e7f3fe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2.5"
          />
          <path
            id="Stroke_5"
            data-name="Stroke 5"
            d="M2.449,0H5.714A2.46,2.46,0,0,1,8.163,2.471V5.764a2.46,2.46,0,0,1-2.449,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.471A2.46,2.46,0,0,1,2.449,0Z"
            transform="translate(0 11.766)"
            fill="none"
            stroke="#e7f3fe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2.5"
          />
          <path
            id="Stroke_7"
            data-name="Stroke 7"
            d="M2.449,0H5.716A2.46,2.46,0,0,1,8.163,2.471V5.764a2.459,2.459,0,0,1-2.448,2.47H2.449A2.46,2.46,0,0,1,0,5.764V2.471A2.46,2.46,0,0,1,2.449,0Z"
            transform="translate(11.837 11.766)"
            fill="none"
            stroke="#e7f3fe"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="2.5"
          />
        </g>
      </svg>
    ),
    color: "#004ab3",
    link: "/dashboard",
    selected: false,
  },
  {
    selected: false,
    id: 2,
    title: "Device",
    name: "device",
    hoveredImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 26"
      >
        <g id="Game" transform="translate(1 1)">
          <path
            id="Stroke_1"
            d="M.53 0v4.494"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#fff"
            strokeWidth="2px"
            transform="translate(7.688 12.377)"
          />
          <path
            id="Stroke_2"
            d="M4.585.519H0"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#fff"
            strokeWidth="2px"
            transform="translate(5.925 14.105)"
          />
          <path
            id="Stroke_3"
            d="M.6.519H.476"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#fff"
            strokeWidth="2px"
            transform="translate(15.435 11.994)"
          />
          <path
            id="Stroke_4"
            d="M.6.519H.476"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#fff"
            strokeWidth="2px"
            transform="translate(17.611 16.284)"
          />
          <path
            id="Stroke_5"
            d="M0 0a1.626 1.626 0 0 0 1.642 1.609h1.267A2.523 2.523 0 0 1 5.447 4.1v.81"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#fff"
            strokeWidth="2px"
            transform="translate(7.287)"
          />
          <path
            id="Stroke_7"
            d="M17.314 18.707q-5.409.092-10.627 0A6.408 6.408 0 0 1 0 12.165V6.586A6.408 6.408 0 0 1 6.687.044q5.249-.09 10.627 0A6.407 6.407 0 0 1 24 6.586v5.579a6.407 6.407 0 0 1-6.686 6.542z"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#fff"
            strokeWidth="2px"
            transform="translate(0 5.248)"
          />
        </g>
      </svg>
    ),
    defaultImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 26"
      >
        <g id="Game" transform="translate(1 1)">
          <path
            id="Stroke_1"
            d="M.53 0v4.494"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#00b938"
            strokeWidth="2px"
            transform="translate(7.688 12.377)"
          />
          <path
            id="Stroke_2"
            d="M4.585.519H0"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#00b938"
            strokeWidth="2px"
            transform="translate(5.925 14.105)"
          />
          <path
            id="Stroke_3"
            d="M.6.519H.476"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#00b938"
            strokeWidth="2px"
            transform="translate(15.435 11.994)"
          />
          <path
            id="Stroke_4"
            d="M.6.519H.476"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#00b938"
            strokeWidth="2px"
            transform="translate(17.611 16.284)"
          />
          <path
            id="Stroke_5"
            d="M0 0a1.626 1.626 0 0 0 1.642 1.609h1.267A2.523 2.523 0 0 1 5.447 4.1v.81"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#00b938"
            strokeWidth="2px"
            transform="translate(7.287)"
          />
          <path
            id="Stroke_7"
            d="M17.314 18.707q-5.409.092-10.627 0A6.408 6.408 0 0 1 0 12.165V6.586A6.408 6.408 0 0 1 6.687.044q5.249-.09 10.627 0A6.407 6.407 0 0 1 24 6.586v5.579a6.407 6.407 0 0 1-6.686 6.542z"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            stroke="#00b938"
            strokeWidth="2px"
            transform="translate(0 5.248)"
          />
        </g>
      </svg>
    ),
    color: "#00b938",
    link: "/dashboard/device-app",
  },
  {
    selected: false,
    id: 2,
    title: "Mission",
    name: "mission",
    hoveredImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g
          id="Group_541"
          data-name="Group 541"
          transform="translate(-0.16 0.161)"
        >
          <g
            id="Ellipse_83"
            data-name="Ellipse 83"
            transform="translate(0.16 -0.161)"
            fill="#FFADaa"
            stroke="#fff"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="12" stroke="none" />
            <circle cx="12" cy="12" r="11" fill="none" />
          </g>
          <g
            id="Polygon_2"
            data-name="Polygon 2"
            transform="translate(2.16 21.839) rotate(-90)"
            fill="#fff"
          >
            <path
              d="M 10 16.10745048522949 L 9.015439987182617 12.40363025665283 C 8.831629753112793 11.71212959289551 8.287870407104492 11.16837024688721 7.596360206604004 10.98456001281738 L 3.892549991607666 10 C 3.892570018768311 10.00000190734863 3.892570018768311 9.999998092651367 3.892570018768311 9.999994277954102 L 7.596370220184326 9.015439987182617 C 8.287870407104492 8.831629753112793 8.831629753112793 8.287870407104492 9.015439987182617 7.596360206604004 L 10 3.892549991607666 L 10.98456001281738 7.596370220184326 C 11.16837024688721 8.287870407104492 11.71214008331299 8.831640243530273 12.40365982055664 9.015439987182617 L 16.10745048522949 10 C 16.10742950439453 9.999998092651367 16.10742950439453 10.00000190734863 16.10742950439453 10.0000057220459 L 12.40363025665283 10.98456001281738 C 11.71212959289551 11.16837024688721 11.16837024688721 11.71212959289551 10.98456001281738 12.403639793396 L 10 16.10745048522949 Z"
              stroke="none"
            />
            <path
              d="M 9.999997138977051 7.785094261169434 L 9.981880187988281 7.853249549865723 C 9.706170082092285 8.890520095825195 8.890520095825195 9.706170082092285 7.853269577026367 9.981880187988281 L 7.785094261169434 10.00000286102295 L 7.853249549865723 10.01811981201172 C 8.890520095825195 10.29382991790771 9.706170082092285 11.1094799041748 9.981880187988281 12.14673042297363 L 10.00000286102295 12.21490573883057 L 10.01811981201172 12.14674949645996 C 10.29382991790771 11.1094799041748 11.1094799041748 10.29382991790771 12.14673042297363 10.01811981201172 L 12.21490573883057 9.999997138977051 L 12.14674949645996 9.981880187988281 C 11.1094799041748 9.706170082092285 10.29382991790771 8.890520095825195 10.01811981201172 7.853269577026367 L 9.999997138977051 7.785094261169434 M 10 2.892549514770508 C 10.41737461090088 2.892549514770508 10.83475017547607 3.140249252319336 10.96644020080566 3.635650634765625 L 11.95100021362305 7.339469909667969 C 12.04314041137695 7.68610954284668 12.31389045715332 7.956859588623047 12.66053009033203 8.048999786376953 L 16.36434936523438 9.033559799194336 C 17.35515022277832 9.296939849853516 17.35515022277832 10.70306015014648 16.36434936523438 10.96644020080566 L 12.66053009033203 11.95100021362305 C 12.31389045715332 12.04314041137695 12.04314041137695 12.31389045715332 11.95100021362305 12.66053009033203 L 10.96644020080566 16.36434936523438 C 10.83475017547607 16.85975074768066 10.41737461090088 17.10745048522949 10 17.10745048522949 C 9.582625389099121 17.10745048522949 9.165249824523926 16.85975074768066 9.033559799194336 16.36434936523438 L 8.048999786376953 12.66053009033203 C 7.956859588623047 12.31389045715332 7.68610954284668 12.04314041137695 7.339469909667969 11.95100021362305 L 3.635650634765625 10.96644020080566 C 2.64484977722168 10.70306015014648 2.64484977722168 9.296939849853516 3.635650634765625 9.033559799194336 L 7.339469909667969 8.048999786376953 C 7.68610954284668 7.956859588623047 7.956859588623047 7.68610954284668 8.048999786376953 7.339469909667969 L 9.033559799194336 3.635650634765625 C 9.165249824523926 3.140249252319336 9.582625389099121 2.892549514770508 10 2.892549514770508 Z"
              stroke="none"
              fill="#ff6e40"
            />
          </g>
        </g>
      </svg>
    ),
    defaultImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g
          id="Group_541"
          data-name="Group 541"
          transform="translate(-0.16 0.161)"
        >
          <g
            id="Ellipse_83"
            data-name="Ellipse 83"
            transform="translate(0.16 -0.161)"
            fill="#fff"
            stroke="#ff6e40"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="12" stroke="none" />
            <circle cx="12" cy="12" r="11" fill="none" />
          </g>
          <g
            id="Polygon_2"
            data-name="Polygon 2"
            transform="translate(2.16 21.839) rotate(-90)"
            fill="#fff"
          >
            <path
              d="M 10 16.10745048522949 L 9.015439987182617 12.40363025665283 C 8.831629753112793 11.71212959289551 8.287870407104492 11.16837024688721 7.596360206604004 10.98456001281738 L 3.892549991607666 10 C 3.892570018768311 10.00000190734863 3.892570018768311 9.999998092651367 3.892570018768311 9.999994277954102 L 7.596370220184326 9.015439987182617 C 8.287870407104492 8.831629753112793 8.831629753112793 8.287870407104492 9.015439987182617 7.596360206604004 L 10 3.892549991607666 L 10.98456001281738 7.596370220184326 C 11.16837024688721 8.287870407104492 11.71214008331299 8.831640243530273 12.40365982055664 9.015439987182617 L 16.10745048522949 10 C 16.10742950439453 9.999998092651367 16.10742950439453 10.00000190734863 16.10742950439453 10.0000057220459 L 12.40363025665283 10.98456001281738 C 11.71212959289551 11.16837024688721 11.16837024688721 11.71212959289551 10.98456001281738 12.403639793396 L 10 16.10745048522949 Z"
              stroke="none"
            />
            <path
              d="M 9.999997138977051 7.785094261169434 L 9.981880187988281 7.853249549865723 C 9.706170082092285 8.890520095825195 8.890520095825195 9.706170082092285 7.853269577026367 9.981880187988281 L 7.785094261169434 10.00000286102295 L 7.853249549865723 10.01811981201172 C 8.890520095825195 10.29382991790771 9.706170082092285 11.1094799041748 9.981880187988281 12.14673042297363 L 10.00000286102295 12.21490573883057 L 10.01811981201172 12.14674949645996 C 10.29382991790771 11.1094799041748 11.1094799041748 10.29382991790771 12.14673042297363 10.01811981201172 L 12.21490573883057 9.999997138977051 L 12.14674949645996 9.981880187988281 C 11.1094799041748 9.706170082092285 10.29382991790771 8.890520095825195 10.01811981201172 7.853269577026367 L 9.999997138977051 7.785094261169434 M 10 2.892549514770508 C 10.41737461090088 2.892549514770508 10.83475017547607 3.140249252319336 10.96644020080566 3.635650634765625 L 11.95100021362305 7.339469909667969 C 12.04314041137695 7.68610954284668 12.31389045715332 7.956859588623047 12.66053009033203 8.048999786376953 L 16.36434936523438 9.033559799194336 C 17.35515022277832 9.296939849853516 17.35515022277832 10.70306015014648 16.36434936523438 10.96644020080566 L 12.66053009033203 11.95100021362305 C 12.31389045715332 12.04314041137695 12.04314041137695 12.31389045715332 11.95100021362305 12.66053009033203 L 10.96644020080566 16.36434936523438 C 10.83475017547607 16.85975074768066 10.41737461090088 17.10745048522949 10 17.10745048522949 C 9.582625389099121 17.10745048522949 9.165249824523926 16.85975074768066 9.033559799194336 16.36434936523438 L 8.048999786376953 12.66053009033203 C 7.956859588623047 12.31389045715332 7.68610954284668 12.04314041137695 7.339469909667969 11.95100021362305 L 3.635650634765625 10.96644020080566 C 2.64484977722168 10.70306015014648 2.64484977722168 9.296939849853516 3.635650634765625 9.033559799194336 L 7.339469909667969 8.048999786376953 C 7.68610954284668 7.956859588623047 7.956859588623047 7.68610954284668 8.048999786376953 7.339469909667969 L 9.033559799194336 3.635650634765625 C 9.165249824523926 3.140249252319336 9.582625389099121 2.892549514770508 10 2.892549514770508 Z"
              stroke="none"
              fill="#ff6e40"
            />
          </g>
        </g>
      </svg>
    ),
    color: "#ff6e40",
    link: "/dashboard/mission-app",
  },
  {
    selected: false,
    id: 3,
    title: "Storage",
    name: "storage",
    hoveredImage: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19.2">
        <path
          data-name="Path 18832"
          d="M2 23.2h24v-4.8H2zm2.4-3.6h2.4V22H4.4zM2 4v4.8h24V4zm4.8 3.6H4.4V5.2h2.4zM2 16h24v-4.8H2zm2.4-3.6h2.4v2.4H4.4z"
          transform="translate(-2 -4)"
          fill="#fff"
        />
      </svg>
    ),
    defaultImage: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19.2">
        <path
          data-name="Path 18832"
          d="M2 23.2h24v-4.8H2zm2.4-3.6h2.4V22H4.4zM2 4v4.8h24V4zm4.8 3.6H4.4V5.2h2.4zM2 16h24v-4.8H2zm2.4-3.6h2.4v2.4H4.4z"
          transform="translate(-2 -4)"
          fill="#9c27b0"
        />
      </svg>
    ),
    color: "#9c27b0",
    link: "/dashboard/storage-app",
  },
  {
    id: 4,
    title: "Admin",
    name: "admin",
    defaultImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.506"
        height="18.5"
        viewBox="0 0 18.506 18.5"
      >
        <g>
          <path
            fill="none"
            stroke="#2699fb"
            strokeWidth="1.5px"
            d="M9.111 17H7.886a1.86 1.86 0 0 1-1.271-.5 1.628 1.628 0 0 1-.518-1.19 1.759 1.759 0 0 0-1.815-1.692 1.847 1.847 0 0 0-.931.248 1.989 1.989 0 0 1-.921.223 2.023 2.023 0 0 1-.466-.054 1.863 1.863 0 0 1-1.109-.79l-.572-.961a1.58 1.58 0 0 1-.224-1.326 1.748 1.748 0 0 1 .884-1.064 1.7 1.7 0 0 0 .671-.62A1.634 1.634 0 0 0 .943 7a1.68 1.68 0 0 1-.832-1.01 1.567 1.567 0 0 1 .171-1.255l.572-.952a1.806 1.806 0 0 1 1.118-.808 1.935 1.935 0 0 1 1.4.179 2.041 2.041 0 0 0 .914.221 1.914 1.914 0 0 0 1.287-.493 1.63 1.63 0 0 0 .527-1.19A1.764 1.764 0 0 1 7.921 0h1.251a1.851 1.851 0 0 1 1.271.485 1.6 1.6 0 0 1 .537 1.207 1.765 1.765 0 0 0 1.826 1.692 1.977 1.977 0 0 0 .9-.23 1.932 1.932 0 0 1 .875-.21 1.844 1.844 0 0 1 1.566.839l.609.994a1.647 1.647 0 0 1 .244.842 1.664 1.664 0 0 1-.912 1.462 1.768 1.768 0 0 0-.671.621 1.63 1.63 0 0 0 .671 2.27 1.645 1.645 0 0 1 .671 2.294l-.609.961a1.834 1.834 0 0 1-1.565.851 1.866 1.866 0 0 1-.912-.231 2.058 2.058 0 0 0-.913-.229 1.881 1.881 0 0 0-1.287.5 1.6 1.6 0 0 0-.538 1.2A1.76 1.76 0 0 1 9.111 17zM8.523 6.177a2.6 2.6 0 0 0-1.775.683A2.22 2.22 0 0 0 6.2 9.4a2.5 2.5 0 0 0 2.32 1.446h.044a2.527 2.527 0 0 0 1.736-.68 2.246 2.246 0 0 0 .743-1.648A2.332 2.332 0 0 0 9.5 6.359a2.667 2.667 0 0 0-.977-.182z"
            transform="translate(7.757 9.75) translate(-7.001 -9)"
          />
        </g>
      </svg>
    ),
    hoveredImage: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18.506"
        height="18.5"
        viewBox="0 0 18.506 18.5"
      >
        <g>
          <path
            fill="none"
            stroke="#2699fb"
            strokeWidth="1.5px"
            d="M9.111 17H7.886a1.86 1.86 0 0 1-1.271-.5 1.628 1.628 0 0 1-.518-1.19 1.759 1.759 0 0 0-1.815-1.692 1.847 1.847 0 0 0-.931.248 1.989 1.989 0 0 1-.921.223 2.023 2.023 0 0 1-.466-.054 1.863 1.863 0 0 1-1.109-.79l-.572-.961a1.58 1.58 0 0 1-.224-1.326 1.748 1.748 0 0 1 .884-1.064 1.7 1.7 0 0 0 .671-.62A1.634 1.634 0 0 0 .943 7a1.68 1.68 0 0 1-.832-1.01 1.567 1.567 0 0 1 .171-1.255l.572-.952a1.806 1.806 0 0 1 1.118-.808 1.935 1.935 0 0 1 1.4.179 2.041 2.041 0 0 0 .914.221 1.914 1.914 0 0 0 1.287-.493 1.63 1.63 0 0 0 .527-1.19A1.764 1.764 0 0 1 7.921 0h1.251a1.851 1.851 0 0 1 1.271.485 1.6 1.6 0 0 1 .537 1.207 1.765 1.765 0 0 0 1.826 1.692 1.977 1.977 0 0 0 .9-.23 1.932 1.932 0 0 1 .875-.21 1.844 1.844 0 0 1 1.566.839l.609.994a1.647 1.647 0 0 1 .244.842 1.664 1.664 0 0 1-.912 1.462 1.768 1.768 0 0 0-.671.621 1.63 1.63 0 0 0 .671 2.27 1.645 1.645 0 0 1 .671 2.294l-.609.961a1.834 1.834 0 0 1-1.565.851 1.866 1.866 0 0 1-.912-.231 2.058 2.058 0 0 0-.913-.229 1.881 1.881 0 0 0-1.287.5 1.6 1.6 0 0 0-.538 1.2A1.76 1.76 0 0 1 9.111 17zM8.523 6.177a2.6 2.6 0 0 0-1.775.683A2.22 2.22 0 0 0 6.2 9.4a2.5 2.5 0 0 0 2.32 1.446h.044a2.527 2.527 0 0 0 1.736-.68 2.246 2.246 0 0 0 .743-1.648A2.332 2.332 0 0 0 9.5 6.359a2.667 2.667 0 0 0-.977-.182z"
            transform="translate(7.757 9.75) translate(-7.001 -9)"
          />
        </g>
      </svg>
    ),
    color: "#2699fb",
    link: "/admin/home",
    selected: false,
  },
];

export const accountInformation = [
  {
    name: "send_code",
    title: "Bringing all solutions in one drone management platform.",
    image: phoneVerification,
    cloud_desc: "",
    ring_desc: "",
    desc: " The signup process is quick and secure. After sign up you will be able to control mission and flight management, account management, report generation, report management and many more exciting drone software features. ",
  },
  {
    name: "verify_code",
    title: "Bringing all solutions in one drone management platform.",
    image: verifyCode,
    cloud_desc:
      "Now that you have verified your phone number, the next step would be to read and accept our agreement. ",
    ring_desc: "",
    desc: " The signup process is quick and secure. After sign up you will be able to control mission and flight management, account management, report generation, report management and many more exciting drone software features. ",
  },
  {
    name: "agreement",
    title: "Bringing all solutions in one drone management platform.",
    cloud_desc: "You can download our full agreement here.",
    image: agreement,
    ring_desc:
      "Next step will be the account information where you can enter your personal or company information.",
    desc: " The signup process is quick and secure. After sign up you will be able to control mission and flight management, account management, report generation, report management and many more exciting drone software features. ",
  },
  {
    name: "information",
    title: "Bringing all solutions in one drone management platform.",
    image: accountInfo,
    cloud_desc:
      "Please fill out the account information and keep in mind that you can always update your information from the admin panel.",
    ring_desc:
      "Next step, you will see a summary of all the information you have provided for final check.",
    desc: " The signup process is quick and secure. After sign up you will be able to control mission and flight management, account management, report generation, report management and many more exciting drone software features. ",
  },
  {
    name: "confirm",
    title: "Bringing all solutions in one drone management platform.",
    image: confirmAccountInfo,
    cloud_desc:
      "If there is anything that you need to update, press modify and after updating the information, press confirm. ",
    ring_desc: "",
    desc: " The signup process is quick and secure. After sign up you will be able to control mission and flight management, account management, report generation, report management and many more exciting drone software features. ",
  },
  {
    name: "lunch",
    title: "Bringing all solutions in one drone management platform.",
    image: getStartedAccount,
    ring_desc:
      "Account has been registered successfully, let’s go through the dashboard! ",
    desc: " The signup process is quick and secure. After sign up you will be able to control mission and flight management, account management, report generation, report management and many more exciting drone software features. ",
  },
];

export const adminItems = [
  {
    title: "Dashboard",
    name: "dashboard",
    icon: <MdOutlineDashboard size="15" />,
    link: "/dashboard",
    active: false,
  },
  {
    title: "Home",
    name: "admin/home",
    icon: <CgHome size="15" />,
    link: "/admin/home",
    active: true,
  },
  {
    title: "Users",
    name: "users",
    icon: <FiUsers size="15" />,
    link: "/admin/users",
  },
  {
    title: "Roles",
    name: "roles",
    icon: <RiShieldUserLine size="15" />,
    link: "/admin/roles",
  },
  {
    title: "Groups",
    name: "groups",
    icon: <TiGroupOutline size="15" />,
    link: "/admin/groups",
  },
  {
    title: "Customers",
    name: "customers",
    icon: <AiOutlineUserSwitch size="15" />,
    link: "/admin/customers",
  },
  {
    title: "Guests",
    name: "guests",
    icon: <GuestAdminIcon size="15" />,
    link: "/admin/guests",
  },
  {
    title: "Devices",
    name: "devices",
    icon: <DeviceAdminIcon size="15" />,
    link: "/admin/devices",
  },
  {
    title: "Docks",
    name: "docks",
    icon: <DockAdminIcon size="15" />,
    link: "/admin/docks",
  },
  {
    title: "Storage",
    name: "storages",
    icon: <MdStorage size="15" />,
    link: "/admin/storages",
  },
  {
    title: "AWS S3",
    name: "amazon",
    icon: <TbBrandAws size="17" />,
    link: "/admin/aws-s3",
  },
  {
    title: "Workspaces",
    name: "workspaces",
    icon: <ImMakeGroup />,
    link: "/admin/workspaces",
  },
  {
    title: "Missions",
    name: "missions",
    icon: <RiRouteFill />,
    link: "/admin/missions",
  },
  {
    title: "Settings",
    name: "settings",
    icon: <TbSettings size="17" />,
    link: "/admin/settings",
  },
];

export const activityFields = [
  { id: 1, name: "Construction", value: "Construction" },
  { id: 2, name: "Building", value: "Building" },
  { id: 3, name: "Public Safety", value: "Public Safety" },
  { id: 4, name: "Agriculture", value: "Agriculture" },
  { id: 5, name: "Photography", value: "Photography" },
];

export const countryPhones = [
  {
    id: 1,
    name: "Australia",
    prefix: "+61",
  },
  {
    id: 2,
    name: "Germany",
    prefix: "+49",
  },
  {
    id: 3,
    name: "United Arab Emirates",
    prefix: "+971",
  },
  {
    id: 4,
    name: "United Kingdom",
    prefix: "+44",
  },
  {
    id: 5,
    name: "United States",
    prefix: "+1",
  },
  {
    id: 6,
    name: "Iran",
    prefix: "+98",
  },
];

export const deviceApps = [
  {
    id: "onboard",
    name: "DJI Controller",
    link: "/dashboard/device-app/onboard/list",
    image: onboardSdk,
    color: "#00b938",
  },
  {
    id: "camera-observer",
    name: "Cam Observer",
    link: "/dashboard/device-app/camera-observer",
    image: cameraObserverApp,
    color: "#A37DEA",
  },
  {
    id: "dock",
    name: "Dock Manager",
    link: "/dashboard/device-app/dock-manager",
    image: dockManagerApp,
    color: "#FFE08F",
  },
];

export const storageApps = [
  {
    id: "container",
    name: "Container App",
    link: "/dashboard/storage-app/container",
    image: containerApp,
    color: "#9c27b0",
  },
];

export const dataStreamingRegions = [
  { id: 1, name: "Australia", value: "Sydney" },
  { id: 2, name: "United Kingdom", value: "London" },
  { id: 3, name: "United States", value: "Chicago" },
];

export const MeasurementSystem = {
  METRIC: "metric",
  IMPERIAL: "imperial",
}

export const MeasurementType = {
  SPEED: "speed",
  DISTANCE: "distance",
  ALTITUDE: "altitude",
  TEMPERATURE: "temperature",
}

export const measurementUnitItems = [
  { id: 1, name: "Metric", value: MeasurementSystem.METRIC },
  { id: 2, name: "Imperial", value: MeasurementSystem.IMPERIAL },
];

export const wsGroupNames = {
  CAMERA_SETTING: "DS_FJ-CamSetting-{id}",
  BATTERY_PERCENT: "DS_FJ-BatteryPercent-{id}",
  FACING: "DS_FJ-Facing-{id}",
};

export const shutter_speeds = [
  "1/8000",
  "1/6400",
  "1/6000",
  "1/5000",
  "1/4000",
  "1/3200",
  "1/3000",
  "1/2500",
  "1/2000",
  "1/1600",
  "1/1500",
  "1/1250",
  "1/1000",
  "1/800",
  "1/725",
  "1/640",
  "1/500",
  "1/400",
  "1/350",
  "1/320",
  "1/250",
  "1/240",
  "1/200",
  "1/180",
  "1/160",
  "1/125",
  "1/120",
  "1/100",
  "1/90",
  "1/80",
  "1/60",
  "1/50",
  "1/40",
  "1/30",
  "1/25",
  "1/20",
  "1/15",
  "1/12.5",
  "1/10",
  "1/8",
  "1/6.25",
  "1/5",
  "1/4",
  "1/3",
  "1/2.5",
  "1/2",
  "1/1.67",
  "1/1.25",
  "1.0",
  "1.3",
  "1.6",
  "2.0",
  "2.5",
  "3.0",
  "3.2",
  "4.0",
  "5.0",
  "6.0",
  "7.0",
  "8.0",
  "9.0",
  "10.0",
  "13.0",
  "15.0",
  "20.0",
  "25.0",
  "30.0",
  "",
  "",
];

export const exposure_values = [
  "-5.0",
  "-4.7",
  "-4.3",
  "-4.0",
  "-3.7",
  "-3.3",
  "-3.0",
  "-2.7",
  "-2.3",
  "-2.0",
  "-1.7",
  "-1.3",
  "-1.0",
  "-0.7",
  "-0.3",
  "0.0",
  "+0.3",
  "+0.7",
  "+1.0",
  "+1.3",
  "+1.7",
  "+2.0",
  "+2.3",
  "+2.7",
  "+3.0",
  "+3.3",
  "+3.7",
  "+4.0",
  "+4.3",
  "+4.7",
  "+5.0",
  "",
  "",
];

export const cameraExposureModes = {
  PROGRAM_AUTO: 1,       /*!< Program mode */
  SHUTTER_PRIORITY: 2,   /*!< Shutter priority mode */
  APERTURE_PRIORITY: 3,  /*!< Aperture priority mode */
  EXPOSURE_MANUAL: 4,    /*!< Manual mode */
  EXPOSURE_UNKNOWN: 0xFF /*!< The camera exposure mode is unknown. */
};

export const cameraFocusModes = {
  AFS: 1,
  AFC: 2,
  MF: 0,
};

export const sdkTypes = {
  DJI_PSDK: 'dji_psdk',
  DJI_CLOUD: 'dji_cloud',
}

export const deviceTypes = {
  DRONE: 'drone',
  DOCK: 'dock',
  DOCK_DRONE: 'dock_drone',
  MOBILE: 'mobile',
}

export const payloadTypes = {
  CAMERA: 'camera',
};

export const payloadSettingsValueTypes = {
  NONE: 'none',
  RANGE: 'range',
  LIST: 'list',
  INDEXED: 'indexed',
  MAP: 'map'
};

export const deviceModels = [
  {
    model: 'M300RTK',
    modelNumber: 60,
    subModelNumber: 0,
    manufacturer: 'DJI',
    enumValue: 60,
    subEnumValue: 0,
    waypointVersion: '2.0.0',
    spec: {
      fpvCamera: {
        aspectRatio: 1,
        resolution: [1920, 1080],
      }
    }
  },
  {
    model: 'M350RTK',
    modelNumber: 89,
    subModelNumber: 0,
    manufacturer: 'DJI',
    waypointVersion: '2.0.0',
  },
  {
    model: 'M30',
    manufacturer: 'DJI',
    enumValue: 67,
    subEnumValue: 0,
    waypointVersion: '3.0.0',
    spec: {
      fpvCamera: {
        aspectRatio: 1,
        resolution: [1920, 1080],
      }
    }
  },
  {
    model: 'M30T',
    manufacturer: 'DJI',
    enumValue: 67,
    subEnumValue: 1,
    waypointVersion: '3.0.0',
    spec: {
      fpvCamera: {
        aspectRatio: 1,
        resolution: [1920, 1080],
      }
    }
  },
  {
    model: 'M3E',
    modelNumber: 77,
    subModelNumber: 0,
    manufacturer: 'DJI',
    waypointVersion: '3.0.0',
  },
  {
    model: 'M3T',
    modelNumber: 77,
    subModelNumber: 1,
    manufacturer: 'DJI',
    waypointVersion: '3.0.0',
  },
  {
    model: 'M3M',
    modelNumber: 77,
    subModelNumber: 2,
    manufacturer: 'DJI',
    waypointVersion: '3.0.0',
  },
  {
    model: 'M3D',
    modelNumber: 91,
    subModelNumber: 0,
    manufacturer: 'DJI',
    waypointVersion: '3.0.0',
    spec: {
      fpvCamera: false,
    }
  },
  {
    model: 'M3TD',
    modelNumber: 93,
    subModelNumber: 1,
    manufacturer: 'DJI',
    waypointVersion: '3.0.0',
    spec: {
      fpvCamera: false,
    }
  },
  {
    model: 'M3E',
    modelNumber: 91,
    subModelNumber: 2,
    manufacturer: 'DJI',
    waypointVersion: '3.0.0',
  }
];

const zenmuseH20Specs = {
  model: 'H20',
  modelNumber: 42,
  title: 'H20',
  manufacturer: 'Zenmuse',
  enumValue: 42,
  type: payloadTypes.CAMERA,
  laserRangeFinder: true,
  settings: {
    exposure: {
      type: payloadSettingsValueTypes.INDEXED,
      values: exposure_values,
    },
    shutterSpeed: {
      type: payloadSettingsValueTypes.INDEXED,
      values: shutter_speeds,
    },
    iso: {
      type: payloadSettingsValueTypes.LIST,
      values: Array.from(Array(9), (v, i) => parseFloat(Math.pow(2, i) * 100)),
    },
    focusMode: {
      type: payloadSettingsValueTypes.MAP,
      values: cameraFocusModes,
    },
    exposureMode: {
      type: payloadSettingsValueTypes.MAP,
      values: {
        manual: cameraExposureModes.EXPOSURE_MANUAL,
        auto: cameraExposureModes.PROGRAM_AUTO
      }
    },
  },
  workModes: {
    photo: {
      id: 1,
      aspectRatio: 1,
    },
    video: {
      id: 0,
      aspectRatio: 1,
    }
  },
  videoSources: {
    wide: {
      id: 1,
      title: 'Wide',
      aspectRatio: 1,
      resolution: [1920, 1080],
    },
    zoom: {
      id: 2,
      title: 'Zoom',
      aspectRatio: 1,
      resolution: [1920, 1080],
    },
  },
};

const zenmuseH20tSpecs = {
  ...zenmuseH20Specs,
  model: 'H20T',
  modelNumber: 43,
  title: 'H20T',
  enumValue: 43,
  videoSources: {
    ...zenmuseH20Specs.videoSources,
    infrared: {
      id: 3,
      title: 'IR',
      aspectRatio: 1,
      resolution: [1920, 1080],
    },
  }
};

const zenmuseH20nSpecs = {
  ...zenmuseH20tSpecs,
  model: 'H20N',
  modelNumber: 61,
  title: 'H20N',
  enumValue: 61,
};

const zenmuseM30Specs = {
  ...zenmuseH20Specs,
  model: 'M30',
  modelNumber: 52,
  title: 'M30',
};

const zenmuseM30tSpecs = {
  ...zenmuseH20tSpecs,
  model: 'M30T',
  modelNumber: 53,
  title: 'M30T',
  enumValue: 53,
};

const mavic3ECameraSpecs = {
  ...zenmuseH20Specs,
  model: '3E',
  modelNumber: 66,
  title: 'Mavic 3E Cam',
};

const mavic3TCameraSpecs = {
  ...zenmuseH20tSpecs,
  model: '3T',
  modelNumber: 67,
  title: 'Mavic 3T Cam',
};

const mavic3MCameraSpecs = {
  ...zenmuseH20Specs,
  model: '3M',
  modelNumber: 68,
  title: 'Mavic 3M Cam',
};

const m3DCameraSpecs = {
  ...zenmuseH20Specs,
  model: 'M3D',
  modelNumber: 80,
  title: 'M3D Cam',
  manufacturer: 'DJI',
  laserRangeFinder: false,
};

const m3TDCameraSpecs = {
  ...zenmuseH20Specs,
  model: 'M3TD',
  modelNumber: 81,
  title: 'M3TD Cam',
  manufacturer: 'DJI',
  laserRangeFinder: false,
  videoSources: {
    ...zenmuseH20Specs.videoSources,
    infrared: {
      id: 3,
      title: 'IR',
      aspectRatio: 1,
      resolution: [1920, 1080],
    },
  }
};

export const devicePayloadSpecs = [
  zenmuseH20Specs,
  zenmuseH20tSpecs,
  zenmuseH20nSpecs,
  zenmuseM30Specs,
  zenmuseM30tSpecs,
  mavic3ECameraSpecs,
  mavic3TCameraSpecs,
  mavic3MCameraSpecs,
  m3DCameraSpecs,
  m3TDCameraSpecs,
];

export const djiWaylineTaskTypes = {
  IMMEDIATE: 0,
  TIMED: 1,
  CONDITIONAL: 2,
}

export const djiWaylineOutOfControlActions = {
  RETURN_HOME: 0,
  HOVERING: 1,
  LANDING: 2,
}